import request from '@/utils/request'

// 取得租戶信息
export function getClient(tenantId) {
  return request({
    url: '/' + tenantId + '/getClient.do',
    method: 'get'
  })
}

// 获取路由
export const getRouters = () => {
  return request({
    url: '/getRouters.do',
    method: 'get'
  })
}

// 登录方法
export function login(userInfo) {
  return request({
    url: '/login.do',
    method: 'post',
    data: userInfo
  })
}

// 切换角色
export function chgRole(userInfo) {
  return request({
    url: '/chgRole.do',
    method: 'post',
    data: userInfo
  })
}

// 获取用户详细信息
export function getUserInfo() {
  return request({
    url: '/getUserInfo.do',
    method: 'get'
  })
}

// 退出方法
export function logout(form) {
  return request({
    url: '/logout.do',
    data: form,
    method: 'post'
  })
}

// 重新加載License
export function getReloadLic(tenantId) {
  return request({
    url: '/' + tenantId + '/initParams.do',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js